import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav'
import {MatSnackBar } from '@angular/material';
// import * as Rx from 'rxjs/Rx';
// import * as moment from 'moment';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SessionService } from '../../../../service/session/session.module';
// import { LoadingService } from '../../../../directive/loading/loading.module';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-measurement-update',
  templateUrl: './measurement-update.component.html',
  styleUrls: ['./measurement-update.component.css']
})
export class MeasurementUpdateComponent implements OnInit {
  @ViewChild('drawer',{static:true})drawerCtrl: MatDrawer;
  complexForm: FormGroup;
  measurementModel = {
    main: {
      uuid: '',
      code: '',
      name: '',
      abbreviation: ''
    },
    system: {
      status: true
    }
  }
  object = JSON.parse(JSON.stringify(this.measurementModel));
  constructor(public fb: FormBuilder, private session: SessionService, public snackBar: MatSnackBar, private router: Router, private activatedRoute: ActivatedRoute) {
    this.complexForm = fb.group({
      // To add a validator, we must first convert the string value into an array. The first item in the array is the default value if any, then the next item in the array is the validator. Here we are adding a required validator meaning that the firstName attribute must have a value in it.
      'code' : [null, Validators.required],
      'abbreviation' : [null, Validators.required],
      'name': [null, Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(100)])],
    })
   }

   ngOnInit() {
     this.activatedRoute.params.subscribe((params: Params) => {
       if(params['uuid'] == 'new'){

       }else{
         // this.loadingService.wait();
          this.object.main.uuid = params['uuid'];
          // cargamos los datos de la BD
          this.session.getRequest('unitMeasure:get',this.object).subscribe((data:any)=>{
            this.object = JSON.parse(JSON.stringify(data.object));
            // this.loadingService.hide();
          },
          (error)=>{
            // this.loadingService.hide();
            console.log('Error:unitMeasure:get',error)
          })

       }
     });
   }

  /*
  funcion para guardar una unidad de medida
  */
  send(object){
    // this.loadingService.show(true,'Guardando registro');
    this.session.getRequest("unitMeasure:update",object).subscribe(
      (data:any) => {
        this.snackBar.open('La unidad de medida se guardo correctamente', '', {
          duration: 8000
        });
        // this.loadingService.hide();
        this.router.navigate(['/admin/unitMeasure/list']);
     },
     error => {
       console.log("unitMeasure:update",error);
       // this.loadingService.hide();
     }
    );
  }


  /*
  funcion para controlar si se abre o cierra el menu
  */
  toogleMenu(ev){
    this.drawerCtrl.opened = ev;
  }
}
